@let table = tableData();
<div
  class="border-theme-blue absolute border-2"
  [ngClass]="{ 'no-pointer': table.confirmed() || !isTableCreationToggled() }"
  [ngStyle]="absoluteTableRect() | rectDisplayStyle"></div>

@for (line of allLines(); track $index) {
  <ct-extraction-table-overlay-line
    [hideEventtarget]="!isTableLineModificationAllowed()"
    [line]="line"
    [tableRect]="tableRect()"
    [dimension]="dimension()"
    (delete)="this.deleteLine(line)"
    (selected)="
      this.pickLines({
        line,
        index:
          $index < table.lines.vertical().length ? $index : $index - table.lines.vertical().length,
      })
    "
    (mouseenter)="arePreviewLinesEnabled.set(false)"
    (mouseleave)="arePreviewLinesEnabled.set(true)" />
}
@if (isTableLineModificationAllowed()) {
  <ct-extraction-table-overlay-move-intersection
    [tableData]="table"
    (setArePreviewLinesEnabled)="arePreviewLinesEnabled.set($event)"
    (mouseDown)="
      pickLines(
        { line: $event.verticalLine, index: $event.verticalIndex },
        { line: $event.horizontalLine, index: $event.horizontalIndex }
      )
    "
    [tableRect]="tableRect()"
    [dimension]="dimension()" />
}
<ct-extraction-table-overlay-preview-lines
  [tableData]="table"
  [tableRect]="tableRect()"
  [dimension]="dimension()"
  [arePreviewLinesEnabled]="arePreviewLinesEnabled()"
  [lassoSelection]="lassoSelection"
  [currentDragInfos]="currentDragInfos()" />
<div
  (mouseenter)="arePreviewLinesEnabled.set(true)"
  (mouseleave)="arePreviewLinesEnabled.set(false)"
  (mousedown)="onOverlayMouseDown($event)"
  (contextmenu)="$event.preventDefault()"
  class="absolute z-30 cursor-crosshair"
  [ngStyle]="absoluteTableRect() | rectDisplayStyle"
  [style.top.px]="tableRect().y[0] * dimension().height">
  <div #overlayMenuAnchor class="flex h-full w-full flex-col items-start">
    @for (_ of table.lines.horizontal().slice(0, -1); track $index) {
      <ct-extraction-table-overlay-row
        [tableData]="table"
        [dimension]="dimension()"
        [rowIndex]="$index"
        [isIgnored]="ignoredRowIndices.has($index)"
        (toggleIgnoreForRow)="toggleRowDisplay($index)" />
    }
  </div>

  @let isOverlayMenuVisible = isOverlayMenuVisible$ | async;
  @if (type() === 'table-extraction' && isOverlayMenuVisible) {
    <ct-extraction-table-overlay-context-menu
      floatingElement
      class="fixed"
      [offsetConfig]="{ main: 5 }"
      [anchor]="overlayMenuAnchor"
      [flip]="false"
      [placement]="'right-start'"
      [isOpened]="isOverlayMenuVisible"
      [tableData]="table"
      [dimension]="dimension()"
      [absoluteTableRect]="absoluteTableRect()"
      (deleteButtonClicked)="openDeletionDialog()"
      (editButtonClicked)="openEditDialog()"
      (magicWandButtonClicked)="detectTable()" />
  }
</div>
@if (table.layoutDefined() || table.confirmed()) {
  <ct-extraction-table-overlay-column-assignment
    [absoluteTableRect]="absoluteTableRect()"
    [tableData]="table"
    [dimension]="dimension()"
    [tableColumnLabelsByKeys]="tableColumnLabelsByKeys()"
    (newTableHeaderAtColumnPosition)="
      setNewTableHeaderForColumn($event.colPos, $event.newHeader)
    " />
}

@if (isTableCreationToggled() && !table.confirmed()) {
  @if (table.layoutDefined()) {
    <ct-extraction-table-overlay-back-button
      class="absolute z-10"
      [style.left.px]="absoluteTableRect().x[0]"
      [style.top.px]="absoluteTableRect().y[1] + 8"
      [tableData]="table"
      (buttonClicked)="undoLayoutDefined()" />
  }

  <ct-extraction-table-overlay-confirm-button
    class="absolute z-10"
    [style.right.px]="dimension().width - absoluteTableRect().x[1]"
    [style.top.px]="absoluteTableRect().y[1] + 8"
    [tableData]="table"
    (buttonClicked)="confirmButtonLogic()" />
}

<ct-extraction-edit-dialog
  #editDialog
  [tableData]="table"
  (acceptedDialog)="editDialogConfirmLogic()" />
<ct-extraction-deletion-dialog
  #deletionDialog
  [tableData]="table"
  (acceptedDialog)="deleteDialogConfirmLogic()" />
